'use client';
import { useState } from 'react';
import { Plus } from 'lucide-react';
import styles from './Faq.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

const FAQ_DATA = [
  {
    question: "O disparo em massa de WhatsApp tem risco de banimento?",
    answer: "Trabalhamos com tecnologia de ponta que utiliza sistemas robustos de Anti-ban. O Aesir ERP possui rotinas inteligentes de rotação, atrasos dinâmicos (delays) entre mensagens e gerenciamento automático de blacklist. Isso simula o comportamento humano e protege a sua operação, maximizando a entrega das suas campanhas."
  },
  {
    question: "Posso vender o Aesir ERP com a minha própria marca (White Label)?",
    answer: "Sim! Se você é uma agência ou consultor, pode ter o Aesir ERP rodando no seu próprio domínio (ex: sistema.suaempresa.com.br), com a sua logomarca e as suas cores. Você define o preço que vai cobrar do cliente final, e a melhor parte: você só nos paga a licença quando o seu cliente já tiver pago você. Crescimento com zero risco."
  },
  {
    question: "A interface é complexa para os meus funcionários aprenderem?",
    answer: "Zero complexidade. Todo o Aesir ERP foi construído utilizando as diretrizes de design do Material You 3 (o mesmo padrão dos aplicativos do Google). As telas são intuitivas, limpas e responsivas. Se a sua equipe sabe usar uma rede social no celular, eles saberão operar nosso PDV e nosso Chat Omnichannel sem a necessidade de longos treinamentos."
  },
  {
    question: "Como funciona a contratação modular?",
    answer: "Ao contrário dos ERPs tradicionais onde você paga pelo 'pacote completo' e usa apenas 10%, no Aesir você ativa exatamente o que precisa. Tem apenas uma loja física? Ative o Módulo de Vendas/PDV. Seu foco é marketing? Ative apenas as Campanhas de WhatsApp e o Chat. Você tem controle total sobre os custos da sua assinatura."
  },
  {
    question: "O sistema emite todas as Notas Fiscais?",
    answer: "Sim. O Módulo Financeiro está preparado para lidar com a burocracia fiscal. Ele emite NFe, NFCe e NFS-e, calculando os impostos automaticamente e integrando as vendas diretamente com o fluxo de caixa da empresa."
  }
];

export function Faq() {
  // Estado para controlar qual FAQ está aberto. -1 significa nenhum.
  const [openIndex, setOpenIndex] = useState<number | null>(0); // Deixa o primeiro aberto por padrão

  const toggleFaq = (index: number) => {
    // Se clicar no que já está aberto, fecha ele. Se clicar em outro, abre o novo.
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className={styles.section}>
      <div className={styles.container}>
        
        <ScrollAnimator>
          <div className={styles.header}>
            <h2>Dúvidas Frequentes</h2>
            <p>Respostas diretas sobre como o Aesir ERP vai escalar a sua operação.</p>
          </div>
        </ScrollAnimator>

        <ScrollAnimator delay={200}>
          <div className={styles.faqList}>
            {FAQ_DATA.map((item, index) => {
              const isOpen = openIndex === index;
              
              return (
                <div key={index} className={`${styles.faqItem} ${isOpen ? styles.open : ''}`}>
                  <button 
                    className={styles.questionBtn} 
                    onClick={() => toggleFaq(index)}
                    aria-expanded={isOpen}
                  >
                    {item.question}
                    <div className={styles.iconWrapper}>
                      <Plus size={20} strokeWidth={2.5} />
                    </div>
                  </button>
                  
                  {/* O uso do max-height via style inline ajuda na transição fluida independente do tamanho do texto */}
                  <div 
                    className={styles.answer} 
                    style={{ maxHeight: isOpen ? '500px' : '0' }}
                  >
                    <div className={styles.answerContent}>
                      {item.answer}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </ScrollAnimator>

      </div>
    </section>
  );
}